import {
  GET_PROJECT_QA_NDT_BOOKINGS,
  GET_PROJECT_QA_NDT_BOOKING,
  CREATE_PROJECT_QA_NDT_BOOKING,
  UPDATE_PROJECT_QA_NDT_BOOKING,
  SEND_PROJECT_QA_NDT_BOOKING_PDF,
  CREATE_PROJECT_QA_NDT_BOOKING_PO,
} from "./actions";

export function ProjectQaNdtBookingsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PROJECT_QA_NDT_BOOKINGS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PROJECT_QA_NDT_BOOKING}_FULFILLED`:
    case `${CREATE_PROJECT_QA_NDT_BOOKING}_FULFILLED`:
    case `${UPDATE_PROJECT_QA_NDT_BOOKING}_FULFILLED`:
    case `${SEND_PROJECT_QA_NDT_BOOKING_PDF}_FULFILLED`:
    case `${CREATE_PROJECT_QA_NDT_BOOKING_PO}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    default:
      return state;
  }
}
